import { render, staticRenderFns } from "./LovModal.vue?vue&type=template&id=232b6bb5"
import script from "./LovModal.vue?vue&type=script&lang=js"
export * from "./LovModal.vue?vue&type=script&lang=js"
import style0 from "./LovModal.vue?vue&type=style&index=0&id=232b6bb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports